import {
  BLACK,
  BORDER_COLOR,
  CHARCOAL_GREY,
  DEACTIVATED_GREY,
  PLAIN_GREY,
  TRANSPARENT,
  WHITE,
} from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_SMALL, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';

interface StylesArgs {
  hasBreak: boolean;
  isCancelled: boolean;
  color: string;
}

export const useStyles = ({ hasBreak, isCancelled, color }: StylesArgs) =>
  makeStyles(
    () => ({
      eventItemWrapper: {
        display: 'flex',
        flexDirection: 'column',
        color: CHARCOAL_GREY,
        minHeight: hasBreak ? 64 : 44,
        backgroundColor: WHITE,
        padding: 0,
        margin: 0,
        '&:hover': {
          backgroundColor: WHITE,
        },
      },
      eventItem: {
        borderTop: `1px solid ${BORDER_COLOR}`,
        display: 'flex',
        width: '100%',
        maxWidth: '100vw',
        height: 44,
      },
      eventTimeWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        flexDirection: 'column',
        borderRight: `2px solid ${isCancelled ? PLAIN_GREY : color}`,
        backgroundColor: isCancelled ? DEACTIVATED_GREY : TRANSPARENT,
        minWidth: 53,
      },
      eventTimeText: {
        color: isCancelled ? PLAIN_GREY : CHARCOAL_GREY,
        fontSize: FONT_SIZE_SMALL,
        fontWeight: 'bold',
        letterSpacing: 0.5,
        lineHeight: '13px',
        textAlign: 'right',
      },
      eventTimeTextLower: {
        fontWeight: 'normal',
      },
      eventInfoWrapper: {
        display: 'flex',
        padding: '10px 5px 10px 10px',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        flexGrow: 1,
        maxWidth: 'calc(100% - 53px)',
      },
      eventNameWrapper: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
      },
      eventNameText: {
        color: isCancelled ? PLAIN_GREY : BLACK,
        fontWeight: 'bold',
        letterSpacing: 0.5,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: FONT_SIZE_SMALLISH,
        lineHeight: '16px',
      },
      eventInfoText: {
        color: isCancelled ? PLAIN_GREY : CHARCOAL_GREY,
        fontWeight: 300,
        letterSpacing: 0.5,
        fontSize: FONT_SIZE_SMALL,
        lineHeight: '13px',
      },
      trainer: {
        fontSize: FONT_SIZE_SMALL,
      },
      eventInfoTextWrapper: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '13px',
      },
      eventBreakTime: {
        fontSize: FONT_SIZE_SMALL,
        display: 'flex',
        alignItems: 'center',
        height: 20,
        background: '#FBFBFE',
        width: '100%',
        borderTop: `1px solid ${BORDER_COLOR}`,
        '& > svg': {
          height: 15,
        },
      },
    }),
    { name: 'CalendarEventItem' },
  );
